import React from 'react'
import { isEqual } from 'lodash'

import ListItem from './ListItem'
import { getAllCompletionIds, isFetching, getCurrentThread, getCurrentThreadKey } from './selectors'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { fetchCompletions } from './actions'
import Loading from '../../components/Loading'
import Bubble from './Bubble'
import { CompletionRole, CompletionState, PilotContextType } from '../../types'
import ScrollableList from './ScrollableList'
import PilotContext from 'bundles/Pilot/contexts/PilotContext'

type Props = {
  bodyScroll?: boolean
  innerRef?: React.RefObject<HTMLDivElement>
}

function List({ bodyScroll = false, innerRef }: Props) {
  const dispatch = useAppDispatch()
  const completionIds = useAppSelector(getAllCompletionIds, isEqual)
  const fetching = useAppSelector(isFetching, isEqual)
  const currentThread = useAppSelector(getCurrentThread, isEqual)
  const currentThreadKey = useAppSelector(getCurrentThreadKey, isEqual)
  const { threadKey: contextThreadKey } = React.useContext<PilotContextType>(PilotContext)

  React.useEffect(() => {
    if (currentThread?.id) {
      const effectiveThreadKey = currentThreadKey || contextThreadKey

      dispatch(
        fetchCompletions({
          threadKey: effectiveThreadKey,
          pilotThreadId: currentThread.id,
        })
      )
    }
  }, [currentThread?.id, currentThreadKey, contextThreadKey])

  return (
    <ScrollableList bodyScroll={bodyScroll} innerRef={innerRef}>
      {0 === completionIds.length && !fetching ? (
        <Bubble
          content='Tell me about your situation.'
          role={CompletionRole.Assistant}
          state={CompletionState.Completed}
          rating={0}
        />
      ) : null}
      {fetching ? <Loading /> : null}
      {completionIds.map(completionId => (
        <ListItem key={completionId} completionId={completionId} />
      ))}
    </ScrollableList>
  )
}

export default List
